document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('dinkn-theme-ready');

document.querySelectorAll('form').forEach((form) => {
  const honeypot = form.querySelector('[data-honeypot]');
  if (!honeypot) return;

  form.addEventListener('submit', (event) => {
    if (honeypot.value.trim()) {
      event.preventDefault();
    }
  });
});


const formatMoney = (cents, format) => {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, format);
  }

  return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  }).format(Number(cents || 0) / 100);
};

const updateGalleryImage = (gallery, imageSrc, imageAlt = '') => {
  if (!gallery || !imageSrc) return;

  gallery.classList.add('is-changing');

  window.setTimeout(() => {
    gallery.src = imageSrc;
    gallery.setAttribute('src', imageSrc);
    gallery.removeAttribute('srcset');
    gallery.removeAttribute('sizes');
    gallery.alt = imageAlt;

    const openButton = gallery.closest('[data-product-lightbox-open]');

    if (openButton) {
      const description = String(imageAlt || '').trim();

      openButton.setAttribute(
        'aria-label',
        description ? `Enlarge ${description}` : 'Enlarge product image'
      );
    }

    gallery.classList.remove('is-changing');
  }, 180);
};

const setActiveThumbnail = (activeThumb) => {
  document.querySelectorAll('[data-media-id]').forEach((thumb) => {
    thumb.classList.remove('is-active');
    thumb.setAttribute('aria-current', 'false');
  });

  if (activeThumb) {
    activeThumb.classList.add('is-active');
    activeThumb.setAttribute('aria-current', 'true');
  }
};

document.querySelectorAll('[data-product-form]').forEach((formWrapper) => {
  const productJson = formWrapper.querySelector('[data-product-json]');
  const variantSelect = formWrapper.querySelector('[data-variant-select]');
  const priceTarget = formWrapper.querySelector('[data-product-price]');
  const compareTarget = formWrapper.querySelector('[data-product-compare]');
  const submitButton = formWrapper.querySelector('[data-add-to-cart]');
  const gallery = document.querySelector('[data-product-gallery-main]');
  const moneyFormat = formWrapper.dataset.moneyFormat || '${{amount}}';

  if (!productJson || !variantSelect) return;

  let product;

  try {
    product = JSON.parse(productJson.textContent);
  } catch (error) {
    return;
  }

  const optionInputs = formWrapper.querySelectorAll('[data-option-position]');

  const getSelectedOptions = () => Array.from(optionInputs)
    .filter((input) => input.checked || input.tagName === 'SELECT')
    .reduce((options, input) => {
      options[Number(input.dataset.optionPosition) - 1] = input.value;
      return options;
    }, []);

  const findVariant = () => {
    if (!optionInputs.length) {
      return product.variants.find((variant) => String(variant.id) === String(variantSelect.value)) || product.variants[0];
    }

    const selectedOptions = getSelectedOptions();

    return product.variants.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );
  };

  const updateVariant = () => {
    const variant = findVariant();

    if (!submitButton) return;

    if (!variant) {
      submitButton.disabled = true;
      submitButton.textContent = submitButton.dataset.unavailableText;
      return;
    }

    variantSelect.value = variant.id;
    submitButton.disabled = !variant.available;
    submitButton.textContent = variant.available ? submitButton.dataset.addText : submitButton.dataset.soldText;

    if (priceTarget) {
      priceTarget.textContent = formatMoney(variant.price, moneyFormat);
    }

    if (compareTarget) {
      compareTarget.textContent =
        variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price, moneyFormat)
          : '';

      compareTarget.hidden = !(variant.compare_at_price > variant.price);
    }

    if (variant.featured_media && gallery) {
      const target = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);

      if (target) {
        const newImage = target.dataset.fullSrc;
        const newAlt = target.dataset.alt || gallery.alt;

        updateGalleryImage(gallery, newImage, newAlt);
        setActiveThumbnail(target);
      }
    }
  };

  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  updateVariant();
});

document.querySelectorAll('[data-quantity]').forEach((quantity) => {
  const input = quantity.querySelector('input');

  quantity.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', () => {
      const step = button.dataset.quantityAdjust === 'increase' ? 1 : -1;
      const nextValue = Math.max(Number(input.min || 0), Number(input.value || 0) + step);

      input.value = nextValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});

document.querySelectorAll('[data-media-id]').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.preventDefault();

    const gallery = document.querySelector('[data-product-gallery-main]');
    if (!gallery) return;

    const newImage = button.dataset.fullSrc;
    const newAlt = button.dataset.alt || gallery.alt;

    updateGalleryImage(gallery, newImage, newAlt);
    setActiveThumbnail(button);
  });
});

document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
  const summary = menu.querySelector(':scope > summary');
  if (!summary) return;

  const openLabel = summary.dataset.openLabel || 'Open menu';
  const closeLabel = summary.dataset.closeLabel || 'Close menu';

  const syncMenuState = () => {
    summary.setAttribute('aria-expanded', String(menu.open));
    summary.setAttribute('aria-label', menu.open ? closeLabel : openLabel);
  };

  menu.addEventListener('toggle', syncMenuState);
  menu.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !menu.open) return;

    event.preventDefault();
    menu.open = false;
    summary.focus();
  });

  syncMenuState();
});

document
  .querySelectorAll('details.mobile-menu a[href$="#rally-list"]')
  .forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details.mobile-menu');
      if (menu) menu.open = false;

      const target = document.querySelector('#rally-list');
      if (target) {
        target.setAttribute('tabindex', '-1');
        requestAnimationFrame(() => {
          target.focus({ preventScroll: true });
        });
      }
    });
  });
